import { APP_INITIALIZER, ApplicationConfig, importProvidersFrom } from '@angular/core';
import { provideRouter, TitleStrategy } from '@angular/router';

import { routes } from './app.routes';
import { BrandService } from '@modules/shared/services/brand.service';
import { BrandTitleStrategy } from './brand-title.strategy';
import { provideClientHydration } from '@angular/platform-browser';
import {
  HTTP_INTERCEPTORS,
  provideHttpClient,
  withFetch,
  withInterceptorsFromDi,
} from '@angular/common/http';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { MAT_FORM_FIELD_DEFAULT_OPTIONS } from '@angular/material/form-field';
import { AuthInterceptorService } from '@modules/auth/services/auth-interceptor.service';
import { CanaryInterceptor } from '@modules/auth/services/interceptors/canary.interceptor';
import { DeviceIdInterceptor } from '@modules/auth/services/interceptors/deviceId.interceptor';
import { UserContextInterceptor } from '@modules/auth/services/interceptors/userContext.interceptor';
import { MAT_SNACK_BAR_DEFAULT_OPTIONS } from '@angular/material/snack-bar';
import { provideLottieOptions } from 'ngx-lottie';
import { RECAPTCHA_SETTINGS } from 'ng-recaptcha-2';
import { environment } from 'environments/environment';
import { provideModalEnterConfirm } from '@modules/shared/providers/modal-enter-confirm.provider';

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(routes),
    provideClientHydration(),
    { provide: TitleStrategy, useClass: BrandTitleStrategy },
    {
      provide: APP_INITIALIZER,
      multi: true,
      useFactory: (brand: BrandService) => () => brand.applyBranding(),
      deps: [BrandService],
    },
    provideModalEnterConfirm(),
    provideHttpClient(withFetch(), withInterceptorsFromDi()),
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptorService,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: CanaryInterceptor,
      multi: true,
    },
    // Contexto de agencia y organización del usuario. El back lo espera del
    // front: sin él, /issuances responde 400 para usuarios ORGANIZATION.
    {
      provide: HTTP_INTERCEPTORS,
      useClass: UserContextInterceptor,
      multi: true,
    },
    // Último de la cadena: adjunta X-Device-Id a TODA request al gateway, incluidas las
    // marcadas noCheckToken (login, refresh) que AuthInterceptorService deja pasar sin
    // tocar headers.
    {
      provide: HTTP_INTERCEPTORS,
      useClass: DeviceIdInterceptor,
      multi: true,
    },
    provideAnimations(),
    provideAnimationsAsync('animations'),
    {
      provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
      useValue: { appearance: 'outline' },
    },
    {
      provide: MAT_SNACK_BAR_DEFAULT_OPTIONS,
      useValue: { duration: 3000 },
    },
    provideLottieOptions({
      player: () => import('lottie-web'),
    }),
    {
      provide: RECAPTCHA_SETTINGS,
      useValue: {
        siteKey: environment.recaptchaV2Key
      }
    }
  ],
};
